import { Link } from "react-router-dom";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="bg-[#f6f6f4] border-t border-black/10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <div className="flex items-center gap-2">
              <img src="/brand/logo.png" alt="DMD Group logo" className="h-12 w-auto" />
              <span className="font-mono text-[10px] tracking-[0.25em] text-[#d81f2a] mt-2">INT.</span>
            </div>
            <p className="mt-4 max-w-sm font-body text-sm text-[#5b6472]">{t("footer_tagline")}</p>
            <div className="mt-6 space-y-2 font-mono text-xs text-[#5b6472]">
              <a href="tel:+905364869008" className="block hover:text-[#d81f2a] transition-colors">+90 536 486 90 08</a>
              <a href="mailto:info@dmdgroup.com.tr" className="block hover:text-[#d81f2a] transition-colors">info@dmdgroup.com.tr</a>
              <a href="https://dmdgroup.com.tr" target="_blank" rel="noreferrer" className="block hover:text-[#d81f2a] transition-colors">dmdgroup.com.tr</a>
            </div>
          </div>
          <div className="flex flex-col gap-3 font-mono text-xs uppercase tracking-widest">
            <a href="#about" className="text-[#5b6472] hover:text-[#0f1115] transition-colors">{t("nav_about")}</a>
            <a href="#products" className="text-[#5b6472] hover:text-[#0f1115] transition-colors">{t("nav_products")}</a>
            <a href="#services" className="text-[#5b6472] hover:text-[#0f1115] transition-colors">{t("nav_services")}</a>
            <Link to="/admin/login" data-testid="footer-admin-link" className="text-[#5b6472] hover:text-[#d81f2a] transition-colors">{t("nav_admin")}</Link>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-black/10 flex flex-col md:flex-row justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#9aa1ac]">
          <span>© {new Date().getFullYear()} DMD GRUP DIŞ TİCARET LTD ŞTİ</span>
          <span>{t("footer_rights")}</span>
        </div>
      </div>
    </footer>
  );
}
